.root {
  position: relative;
  display: grid;
  gap: 12px;
  margin-bottom: 16px;
}

.bar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.round {
  width: 40px;
  height: 40px;
  padding: 0;
  display: grid;
  place-items: center;
  font-size: 20px;
  line-height: 1;
}

.range {
  min-width: 150px;
  text-align: center;
  font-size: 15px;
}

.spacer {
  flex: 1;
}

.week {
  display: grid;
  grid-template-columns: repeat(7, minmax(96px, 1fr));
  gap: 10px;
  overflow-x: auto;
  scrollbar-width: none;
  padding-bottom: 2px;
}

.day {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  min-height: 196px;
  padding: 12px 8px 10px;
  border: 1px solid var(--line);
  border-radius: 20px;
  background: color-mix(in srgb, var(--surface) 70%, transparent);
  background-image: none;
  color: var(--text);
  font-weight: 400;
  line-height: 1.2;
}

.day:hover:not(:disabled) {
  opacity: 1;
  background: var(--pill-bg);
  border-color: var(--pill-line);
}

.day[aria-pressed='true'] {
  background: var(--fill);
  background-image: var(--fill-gradient);
  border-color: var(--fill);
  color: var(--on-fill);
}

.day[data-today]:not([aria-pressed='true']) {
  border-color: var(--accent);
}

.dayWeek {
  font-size: 11px;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  opacity: 0.8;
}

.dayNum {
  font-family: var(--font-display);
  font-size: 26px;
  font-variant-numeric: lining-nums tabular-nums;
}

.dayState {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 11px;
  opacity: 0.9;
}

.dot,
.calDot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  border: 1px solid currentColor;
  box-sizing: border-box;
  opacity: 0.6;
}

[data-state='published'] > .dayState .dot,
[data-state='published'] > .calDot {
  border-color: var(--ok);
  background: var(--ok);
  opacity: 1;
}

[data-state='draft'] > .dayState .dot,
[data-state='draft'] > .calDot {
  border-color: var(--accent);
  background: var(--accent);
  opacity: 1;
}

.calDay[data-state='empty'] > .calDot {
  border-color: transparent;
}

.faces {
  flex: 1;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  padding-top: 6px;
}

.face {
  width: 44px;
  aspect-ratio: 180 / 314;
}

.face img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
}

.faces[data-trio] .face {
  width: 32px;
}

.faces[data-trio] .face + .face {
  margin-left: -10px;
}

.faces[data-trio] .face:first-child {
  transform: rotate(-8deg);
}

.faces[data-trio] .face:last-child {
  transform: rotate(8deg);
}

.faceName {
  border: 1px solid var(--line);
  border-radius: 6px;
  background: var(--surface);
  display: grid;
  place-items: center;
  width: 100%;
  height: 100%;
  padding: 2px;
  box-sizing: border-box;
  font-family: var(--font-display);
  font-size: 9px;
  text-align: center;
  color: var(--text);
}

.caption {
  min-height: 15px;
  max-width: 100%;
  font-size: 12px;
  opacity: 0.85;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.calendar {
  position: absolute;
  top: 48px;
  left: 0;
  z-index: 5;
  width: 320px;
  max-width: 100%;
  display: grid;
  gap: 10px;
  padding: 16px;
  border-radius: 20px;
  border: 1px solid var(--line);
  background: var(--bg-raised, var(--surface));
  box-shadow: 0 20px 40px rgb(0 0 0 / 0.3);
}

.calHead {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-family: var(--font-display);
  font-size: 18px;
}

.calGrid {
  display: grid;
  grid-template-columns: repeat(7, minmax(0, 1fr));
  gap: 4px;
}

.calWeek {
  font-size: 11px;
  text-align: center;
  color: var(--muted);
}

.calDay {
  height: 40px;
  padding: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
  border-radius: 10px;
  background: transparent;
  background-image: none;
  color: var(--text);
  font-size: 13px;
}

.calDay[data-out] {
  opacity: 0.35;
}

.calDay[data-today] {
  box-shadow: inset 0 0 0 1px var(--accent);
}

.calDay[aria-pressed='true'] {
  background: var(--fill);
  background-image: var(--fill-gradient);
  color: var(--on-fill);
}

.note {
  font-size: 12px;
  color: var(--muted);
}
